<template>
  <div>
    <h1 v-bind:style="{ color: titleColor }">
      {{ title }}
    </h1>
    <div class="sub-text">
      <p v-bind:style="{ color: textColor }">{{ replacedText }}</p>
    </div>
  </div>
</template>

<script>
import { getParameterByName } from "../helpers";

export default {
  name: "ThankYouMultiAction",
  data: function () {
    return {
      firstName: null,
      lastName: null,
      frequency: null,
      amount: null,
      replacedText: "",
    };
  },
  props: {
    title: {
      type: String,
      default: "Thank You!",
    },
    text: {
      type: String,
      default:
        "{{firstName}} {{lastName}}, thank you for your {{frequency}} donation of ${{amount}}.",
    },
    titleColor: {
      type: String,
    },
    textColor: {
      type: String,
    },
  },
  created: function () {
    let q = getParameterByName("q");
    if (q) {
      let decodeq = "?" + window.atob(q);
      console.log("decodeq", decodeq);
      this.firstName = getParameterByName("firstname", decodeq);
      this.lastName = getParameterByName("lastname", decodeq);
      this.frequency = getParameterByName("frequency", decodeq);
      this.amount = getParameterByName("amount", decodeq);

      this.frequency = this.frequency
        ? this.frequency.toLowerCase()
        : this.frequency;

      console.log("firstname", this.firstName);

      this.replacedText = this.text
        .replace(/{{firstName}}/gi, this.firstName ? this.firstName : "")
        .replace(/{{lastName}}/gi, this.lastName ? this.lastName : "")
        .replace(/{{frequency}}/gi, this.frequency ? this.frequency : "")
        .replace(/{{amount}}/gi, this.amount ? this.amount : "");
    }
  },
};
</script>

<style scoped>
h1 {
  text-align: center;
  text-transform: none;
}

/* TABLET */
@media screen and (min-width: 640px) {
  h1 {
    font-size: 120px;
    line-height: 120px;
  }
}

.sub-text {
  padding-top: 2rem;
}

.sub-text p {
  font-size: 20px;
  text-align: center;
}
</style>


// WEBPACK FOOTER //
// thankYouMultiAction.vue?f830fd22